import {
  IonButton,
  IonButtons,
  IonFabButton,
  IonContent,
  IonIcon,
  IonModal,
  IonPage,
  IonText,
  useIonModal
} from "@ionic/react";
import { Form, Formik } from "formik";
import { closeOutline, chevronBack } from "ionicons/icons";
import { useRef } from "react";
import { useHistory, useLocation } from "react-router";
import { getProfileValidationSchema } from "../components/forms/getValidationSchema";
import TextInput from "../components/forms/TextInput";
import validate from "../components/forms/validate";
import { registerWithEmailAndPassword, setAccount } from "../lib/firebase";
import TermsAndConditions from "./Terms";
import HtmlFile from "../components/HtmlFile";

const CompleteProfile: React.FC = () => {
  const history = useHistory();
  const location: any = useLocation();
  const email = location?.state?.email;

  const privacyModal = useRef<HTMLIonModalElement>(null);
  const [presentTermsModal, dismissTermsModal] = useIonModal(
    TermsAndConditions,
    {
      dismiss: () => dismissTermsModal()
    }
  );

  const submitForm = async (values: any, { setSubmitting }: any) => {
    const { firstName, lastName, username, email, password } = values;
    const userId = await registerWithEmailAndPassword(email, password);
    if (userId) {
      await setAccount(userId, {
        firstName,
        lastName,
        username,
        email,
        userId
      });
      // navigate to /dashboard
      window.location.href = "/dashboard";
      // history.replace("/dashboard");
    }
    setSubmitting(false);
  };

  return (
    <IonPage>
      <IonContent fullscreen>
        <IonButtons className="fixed top-12 left-6">
          <IonFabButton
            color="PurpleBGBlackCross"
            onClick={() => history.goBack()}
          >
            <IonIcon icon={chevronBack} />
          </IonFabButton>
        </IonButtons>
        <div className="font-base text-4xl mt-32 mx-6 mb-5">
          Complete your Profile
        </div>
        <Formik
          initialValues={{
            firstName: "",
            lastName: "",
            username: "",
            email,
            password: ""
          }}
          validate={validate(getProfileValidationSchema)}
          onSubmit={submitForm}
        >
          {({ isSubmitting, errors, isValid }) => (
            <Form>
              <div className="font-base  mx-6 mb-2">First name</div>
              <TextInput
                name="firstName"
                label="First name"
                placeholder="Enter your first name"
                className="rounded-[4px] mb-6"
              />
              <div className="font-base  mx-6 mb-2">Last name</div>
              <TextInput
                name="lastName"
                label="Last name"
                placeholder="Enter your last name"
                className="rounded-[4px] mb-8 "
              />

              <div className="border-t border-dashed  border-primary-70 mx-6 mb-6"></div>
              <div className="font-base  mx-6 mb-2">Username</div>
              <TextInput
                name="username"
                label="Username"
                placeholder="Create your Username"
                className="mb-4"
              />
              <div className="font-base  mx-6 mb-2">Password</div>
              <TextInput
                name="password"
                label="Password:"
                placeholder="Create your
                 Password"
                type="password"
              />
              {/* <div className="text-sm mx-6 mt-6">
                Password must be at least 8 characters and contain at least 1
                lowercase, 1 uppercase, and 1 number
              </div> */}
              <div className="mx-6 mt-12 text-sm">
                By accepting Agree and Continue, I agree to QuidPro's{" "}
                <IonText
                  color="dark"
                  className="underline text-sm font-bold cursor-pointer"
                  onClick={() => presentTermsModal()}
                >
                  {"Terms of Service"}
                </IonText>
                {" & "}
                <IonText
                  color="dark"
                  className="underline  text-sm font-bold cursor-pointer"
                  id="open-privacy"
                >
                  {"Privacy Policy"}
                </IonText>
              </div>
              <IonButton
                expand="block"
                color="primary"
                type="submit"
                className="mx-6 mt-8 mb-16 h-12 normal-case"
                disabled={isSubmitting || !isValid}
              >
                Agree and Continue
              </IonButton>
            </Form>
          )}
        </Formik>

        <IonModal ref={privacyModal} trigger="open-privacy">
          <IonContent fullscreen>
            <IonButtons className="fixed top-12 left-3">
              <IonButton
                color="dark"
                onClick={() => privacyModal.current?.dismiss()}
              >
                <IonIcon icon={closeOutline} />
              </IonButton>
            </IonButtons>
            <div className="font-bold text-4xl mt-24 mx-6 mb-5">
              Privacy Policy
            </div>
            <HtmlFile htmlFilePath="../assets/templates/privacy.html" />
            <IonButton
              expand="block"
              color="primary"
              type="submit"
              className="mx-6 mt-12 h-12 normal-case"
              onClick={() => privacyModal.current?.dismiss()}
            >
              Close
            </IonButton>
          </IonContent>
        </IonModal>
      </IonContent>
    </IonPage>
  );
};

export default CompleteProfile;
